import React from 'react';
import '../App.css';
import ConfidenceBadge from './ConfidenceBadge';

function MatchCard({ match }) {
  const { home_team, away_team, venue, prediction, result } = match;
  const top_factors = prediction?.top_factors;

  // Team colors mapping
  const teamColors = {
    "Adelaide": ["#003366", "#FFCC00"],
    "Brisbane Lions": ["#6C1D45", "#FFCC00"],
    "Carlton": ["#0E1E2D", "#FFFFFF"],
    "Collingwood": ["#000000", "#FFFFFF"],
    "Essendon": ["#CC2031", "#000000"],
    "Fremantle": ["#2A1A54", "#FFFFFF"],
    "Geelong": ["#002B5C", "#FFFFFF"],
    "Gold Coast": ["#FF8C00", "#E4002B"],
    "Greater Western Sydney": ["#FF5E00", "#7B7F7F"],
    "Hawthorn": ["#4D2004", "#FBBF15"],
    "Melbourne": ["#E4002B", "#001C56"],
    "North Melbourne": ["#003D73", "#FFFFFF"],
    "Port Adelaide": ["#003B5C", "#FFFFFF"],
    "Richmond": ["#FFC72C", "#000000"],
    "St Kilda": ["#E4002B", "#FFFFFF"],
    "Sydney": ["#E4002B", "#FFFFFF"],
    "West Coast": ["#003087", "#FFCD00"],
    "Western Bulldogs": ["#1D428A", "#E30613"]
  };

  const getTeamColors = (teamName) => {
    return teamColors[teamName] || ["#999999", "#CCCCCC"];
  };

  const homeColors = getTeamColors(home_team);
  const awayColors = getTeamColors(away_team);

  return (
    <div className="match-card">
      {/* Teams Section */}
      <div className="match-teams-section">
        <div className={`team-row ${prediction?.predicted_winner === home_team ? 'predicted-winner' : ''}`}>
          <span className="team-color-indicator" style={{
            background: `linear-gradient(90deg, ${homeColors[0]} 50%, ${homeColors[1]} 50%)`
          }}></span>
          <span className="team-name">{home_team}</span>
        </div>
        <div className="vs-divider">vs</div>
        <div className={`team-row ${prediction?.predicted_winner === away_team ? 'predicted-winner' : ''}`}>
          <span className="team-color-indicator" style={{
            background: `linear-gradient(90deg, ${awayColors[0]} 50%, ${awayColors[1]} 50%)`
          }}></span>
          <span className="team-name">{away_team}</span>
        </div>
      </div>

      {/* Venue */}
      <div className="match-venue">
        <span className="venue-text">{venue}</span>
      </div>

      {/* Prediction Section */}
      <div className="match-prediction-section">
        {prediction ? (
          <>
            <ConfidenceBadge confidence={prediction.confidence} />
            <div className="prediction-info">
              <div className="predicted-team">{prediction.predicted_winner}</div>
              <div className="prediction-probs">
                {(prediction.home_win_prob * 100).toFixed(0)}% / {(prediction.away_win_prob * 100).toFixed(0)}%
              </div>
            </div>
          </>
        ) : (
          <div className="prediction-info">
            <div className="predicted-team">—</div>
          </div>
        )}
      </div>

      {/* Result + Top Factors — share one grid cell */}
      <div className="match-info-section">
        {result && (
          <div className="match-result-section">
            {result.correct != null && (
              <span className={`result-indicator ${result.correct ? 'correct' : 'incorrect'}`}>
                {result.correct ? '✓' : '✗'}
              </span>
            )}
            <div className="result-scores">
              <div className="result-score">
                {result.home_score}
                {result.winning_team === home_team && <span className="winner-indicator">★</span>}
              </div>
              <div className="result-score">
                {result.away_score}
                {result.winning_team === away_team && <span className="winner-indicator">★</span>}
              </div>
            </div>
            <div className="result-margin">by {result.margin}</div>
          </div>
        )}
        <div className="match-factors-section">
          {top_factors && top_factors.length > 0 ? (
            <div className="factors-compact">
              {top_factors.map((factor, idx) => (
                <span key={idx} className="factor-item">
                  {factor.description}
                </span>
              ))}
            </div>
          ) : (
            <span className="no-factors-text">-</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default MatchCard;
